var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showLidarPanel && _vm.lidarPanelVisible
    ? _c("div", { staticClass: "ldt-panel" }, [
        _c(
          "div",
          { staticClass: "ldt-header" },
          [
            _c(
              "div",
              { staticClass: "ldt-header-left" },
              [
                _c("fa", {
                  staticClass: "ldt-header-ico",
                  attrs: { icon: ["fas", "layer-group"] },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "ldt-header-title" }, [
                  _vm._v("Lidar Groups"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("fa", {
              staticClass: "ldt-header-toggle",
              attrs: {
                id: "minOrMaxLidarPanelElement",
                title: _vm.lidarMinimized ? "Expand" : "Collapse",
                icon: [
                  "fas",
                  _vm.lidarMinimized ? "chevron-down" : "chevron-up",
                ],
              },
              on: {
                click: function ($event) {
                  return _vm.toggleLidarHeight()
                },
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        !_vm.lidarMinimized
          ? _c(
              "div",
              { staticClass: "ldt-body scrollable" },
              [
                !_vm.lidarIsLoading && _vm.distinct_lidar.length > 0
                  ? _vm._l(_vm.distinct_lidar, function (IDobj) {
                      return _c(
                        "div",
                        { key: IDobj.dateCode, staticClass: "ldt-group" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "ldt-group-row",
                              class: {
                                "ldt-group-row--active":
                                  _vm.anyPointcloudOfLidarGroupVisible(
                                    IDobj.dateCode
                                  ) === "btn-primary",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleLidarGroup(
                                    IDobj,
                                    true,
                                    $event
                                  )
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "ldt-group-name" }, [
                                _vm._v(_vm._s(IDobj.dateCode)),
                              ]),
                              _vm._v(" "),
                              _c("fa", {
                                staticClass: "ldt-group-caret",
                                class: {
                                  "ldt-group-caret--open":
                                    !IDobj.groupIsCollapsed,
                                },
                                attrs: { icon: ["fas", "chevron-right"] },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.expandLidarGroup(IDobj)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "ldt-slide" } }, [
                            !IDobj.groupIsCollapsed
                              ? _c(
                                  "div",
                                  { staticClass: "ldt-chips" },
                                  _vm._l(
                                    IDobj.pointcloudIDArr,
                                    function (pointcloudID) {
                                      return _c(
                                        "button",
                                        {
                                          key: pointcloudID,
                                          staticClass: "ldt-chip",
                                          class: {
                                            "ldt-chip--on":
                                              _vm.availableLidarButtonCtrl(
                                                pointcloudID
                                              ) === "btn-primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toggleLidarLayer(
                                                pointcloudID,
                                                IDobj.dateCode
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(pointcloudID) +
                                              "\n            "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]),
                        ],
                        1
                      )
                    })
                  : !_vm.lidarMinZoomAchieved
                  ? _c(
                      "div",
                      { staticClass: "ldt-state" },
                      [
                        _c("fa", {
                          staticClass: "ldt-state-ico ldt-state-ico--blue",
                          attrs: { icon: ["fas", "search-location"] },
                        }),
                        _vm._v(" "),
                        _vm._m(0),
                      ],
                      1
                    )
                  : _vm.lidarIsLoading
                  ? _c(
                      "div",
                      { staticClass: "ldt-state" },
                      [
                        _c("fa", {
                          staticClass: "ldt-state-ico fa-spin",
                          attrs: { icon: ["fas", "spinner"] },
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "ldt-state-msg" }, [
                          _vm._v("Loading lidar..."),
                        ]),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "ldt-state" },
                      [
                        _c("fa", {
                          staticClass: "ldt-state-ico ldt-state-ico--muted",
                          attrs: { icon: ["fas", "map-marked-alt"] },
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "ldt-state-msg" }, [
                          _vm._v("No lidar at this location"),
                        ]),
                      ],
                      1
                    ),
              ],
              2
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "ldt-state-msg" }, [
      _vm._v("Zoom to level "),
      _c("strong", [_vm._v("17+")]),
      _vm._v(" to load lidar"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }